import { render, staticRenderFns } from "./UploadImageView.vue?vue&type=template&id=0e4c5cb6&slot=no-body&"
import script from "./UploadImageView.vue?vue&type=script&lang=js&"
export * from "./UploadImageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports